<template>
    <kgr-loading v-if="loading" />
    <div v-else>
        <div>
            <div class="kgr-alert kgr-alert--info kgr-row">
                {{ tInfoText }}
            </div>
            <div class="kgr-row">
                <kgr-letter-draft-select
                    v-model="letterDraft.draft"
                    :club-id="clubId"
                    entity="dog"
                />
            </div>
            <kgr-form-row
                :label="tLabelClubFee"
                :error="error"
                field-name="clubFee"
            >
                <kgr-club-fee-select
                    v-model="letterDraft.clubFee"
                    :club-id="clubId"
                    hide-label
                />
            </kgr-form-row>
            <kgr-form-row
                :label="tLabelSendLetter"
                :error="error"
                field-name="sendLetter"
            >
                <kgr-checkbox
                    v-model="letterDraft.sendLetter"
                />
            </kgr-form-row>
            <div v-if="letterDraft.sendLetter">
                <kgr-form-row
                    :label="tLabelEmail"
                    :error="error"
                    field-name="senderEmail"
                >
                    <kgr-dropdown
                        v-model="letterDraft.senderEmail"
                        display="email"
                        :options="emailOptions"
                    />
                </kgr-form-row>
                <kgr-form-row
                    :label="tLabelSubject"
                    :error="error"
                    field-name="subject"
                >
                    <kgr-text-input v-model="letterDraft.subject" />
                </kgr-form-row>
                <kgr-form-row
                    :label="tLabelMessage"
                    :error="error"
                    field-name="message"
                >
                    <textarea
                        v-model.trim="letterDraft.message"
                        type="text"
                        rows="5"
                        class="kgr-input"
                    ></textarea>
                </kgr-form-row>
            </div>
            <hr class="kgr-separator" />
            <div class="kgr-row">
                <button
                    class="kgr-button"
                    @click="$emit('onClose')"
                >
                    {{ tButtonCancel }}
                </button>
                <button
                    class="kgr-button"
                    :value="tButtonExecuteTestRun"
                    :disabled="!isValidData"
                    @click="sendLetterDraft(true)"
                >
                    {{ tButtonExecuteTestRun }}
                </button>
                <button
                    class="kgr-button kgr-button--danger"
                    :value="tButtonExecute"
                    :disabled="!isValidData"
                    @click="sendLetterDraft(false)"
                >
                    {{ tButtonExecute }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import BatchCreateLetterDraft from './BatchCreateLetterDraft.js';
import Checkbox from '../../../../../common/form/checkbox/Checkbox.vue';
import ClubFeeSelect from '../../../../../common/form/select/ClubFeeSelect.vue';
import DropDown from '../../../../../common/form/select/Dropdown.vue';
import Error from '../../../../../../js/model/Error';
import FormRow from '../../../../../common/form/FormRow';
import LetterDraftSelect from '../../../../../common/form/select/LetterDraftSelect.vue';
import LetterDraftSendersRepository from '../../../../../../js/repository/LetterDraftSendersRepository.js';
import Loading from '../../../../../common/Loading.vue';
import TextInput from '../../../../../common/form/input/TextInput.vue';

export default {
    components: {
        'kgr-loading': Loading,
        'kgr-form-row': FormRow,
        'kgr-letter-draft-select': LetterDraftSelect,
        'kgr-club-fee-select': ClubFeeSelect,
        'kgr-text-input': TextInput,
        'kgr-dropdown': DropDown,
        'kgr-checkbox': Checkbox,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        listId: {
            type: Number,
            required: true,
        },
        entityIds: {
            type: Array,
            required: true,
        },
        loading: {
            type: Boolean,
            required: true,
        },
        savedActionData: {
            type: Object,
            required: false,
            default: () => null,
        },
    },
    data() {
        return {
            letterDraft: new BatchCreateLetterDraft(),
            error: new Error(),
            emailOptions: [],
        };
    },
    computed: {
        tButtonCancel() {
            return this.$t('cancel');
        },
        tInfoText() {
            return this.$t('Lists.actions.CreateLetterDraft.infoText', { count: this.entityIds.length });
        },
        tLabelClubFee() {
            return this.$t('Lists.actions.CreateLetterDraft.form.clubFee');
        },
        tLabelSendLetter() {
            return this.$t('Lists.actions.CreateLetterDraft.form.sendLetter');
        },
        tButtonExecute() {
            return this.$t('Ausführen');
        },
        tButtonExecuteTestRun() {
            return this.$t('Lists.actions.executeTestRun');
        },
        tLabelSubject() {
            return this.$t('Lists.actions.SendLetterDraft.form.subject');
        },
        tLabelMessage() {
            return this.$t('Lists.actions.SendLetterDraft.form.message');
        },
        tLabelEmail() {
            return this.$t('Lists.actions.SendLetterDraft.form.email');
        },
        isValidData() {
            return this.letterDraft.isValid();
        },
    },
    created() {
        LetterDraftSendersRepository.findAll(this.clubId).then((data) => {
            this.emailOptions = data;
        });
    },
    mounted() {
        this.assignDefaultData();
    },
    updated() {
        this.assignDefaultData();
    },
    methods: {
        sendLetterDraft(isTestRun) {
            if (!this.letterDraft.isValid()) {
                return;
            }
            this.$emit('executeAction', this.letterDraft, isTestRun);
        },
        assignDefaultData() {
            this.letterDraft.ids = this.entityIds;
            if (this.savedActionData !== null && this.savedActionData instanceof BatchCreateLetterDraft) {
                this.letterDraft = this.savedActionData;
            }
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
